export interface TwoFactorBackupCodeItem {
  code: string
  used: boolean
}

export interface TwoFactorBackupCodes {
  items: TwoFactorBackupCodeItem[]
}

export function backupCodesFromPlainCodes (codes: string[]): TwoFactorBackupCodes {
  return {
    items: codes.map(code => ({ code, used: false }))
  }
}
